var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.app_ready
    ? _c(
        "v-app",
        { class: { bookStyle: _vm.bookStyle }, attrs: { id: "all" } },
        [
          _vm.bookStyle
            ? _c("div", { staticClass: "book2024-discontinued-banner" }, [
                _vm._v(
                  "\n    2024 解答之书已停止贩售，已购买的会员仍然可以继续使用。\n  "
                )
              ])
            : _vm._e(),
          _c("NavBar", {
            class: { "book-nav-offset": _vm.bookStyle },
            attrs: { navlogined: _vm.afterLogin }
          }),
          _c("v-main", [_c("router-view")], 1),
          !_vm.isLandingPage ? _c("Footer") : _vm._e(),
          _c("Toast"),
          _vm.loading || _vm.loading_force ? _c("loadingAnimation") : _vm._e(),
          _c("Warnging"),
          _c("Message"),
          _c("AlreadyWriteVue"),
          _c("Notice"),
          _c("ImageNotice"),
          _vm.showRegistation ? _c("Registration") : _vm._e(),
          _vm.todayIsNewMoon && _vm.showNewMoonNotice
            ? _c("NewMoonCTAVue", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.excludeNewMoonCTA.includes(
                      _vm.currentRouteName
                    ),
                    expression: "!excludeNewMoonCTA.includes(currentRouteName)"
                  }
                ]
              })
            : _vm._e(),
          _c("SelectAstrolabePopup"),
          _c("ServiceAd", {
            ref: "serviceAd",
            attrs: {
              "service-id": "astro-calendar-2026",
              mobileImage: _vm.serviceAdImage.mobile,
              largeImage: _vm.serviceAdImage.large,
              productCode: "Calendar2026",
              isLoggedIn: _vm.afterLogin,
              shouldHide: _vm.isHideServiceAd
            },
            on: { close: _vm.onServiceAdClose }
          }),
          _vm.showAstroCalendarNoticeDialog
            ? _c("AstroCalendarNoticeDialog", {
                staticClass: "lockScroll",
                on: {
                  close: function($event) {
                    _vm.showAstroCalendarNoticeDialog = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }